const C = {
  name: "Microphone",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 0C9.78771 0 8 1.78772 8 4V10C8 12.2123 9.78771 14 12 14C14.2123 14 16 12.2123 16 10V4C16 1.78772 14.2123 0 12 0ZM10 4C10 2.89228 10.8923 2 12 2C13.1077 2 14 2.89228 14 4V10C14 11.1077 13.1077 12 12 12C10.8923 12 10 11.1077 10 10V4Z" fill="currentColor"/>
<path d="M6 10C6 11.5944 6.63434 13.1201 7.75711 14.2429C8.87987 15.3657 10.4056 16 12 16C13.5944 16 15.1201 15.3657 16.2429 14.2429C17.3657 13.1201 18 11.5944 18 10V7H20V10C20 12.1256 19.1543 14.1599 17.6571 15.6571C16.3967 16.9175 14.7557 17.7162 13 17.9373V22H17V24H7V22H11V17.9373C9.24429 17.7162 7.60331 16.9175 6.34289 15.6571C4.84566 14.1599 4 12.1256 4 10V7H6V10Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Microphone
};
